/*
 * Renders a CMS-published 'page' content item for any unmatched route,
 * or the real 404 page when no published page owns the slug.
 */
import React from 'react';
import { useParams } from 'react-router-dom';
import { useSite } from '../content/SiteContext';
import { PageMeta, PageHero } from '../components/ui';
import NotFound from './NotFound';

const CmsPage = () => {
  const { slug } = useParams();
  const { PAGES, getPage } = useSite();
  if (!PAGES.length) return <NotFound />;
  const page = getPage(slug || '');
  if (!page) return <NotFound />;
  return (
    <>
      <PageMeta title={page.title} description={page.description} path={`/${page.slug}`} crumbs={[{ name: page.name || page.h1, path: `/${page.slug}` }]} />
      <PageHero title={page.h1}>
        {page.intro && <p>{page.intro}</p>}
      </PageHero>
      <section className="section">
        <div className="container container--narrow prose">
          {page.featuredImage && <img src={page.featuredImage} alt="" className="cms-page__hero-img" />}
          {(page.sections || []).map((s, i) => (
            <React.Fragment key={i}>
              {s.h && <h2>{s.h}</h2>}
              {s.p && <p>{s.p}</p>}
            </React.Fragment>
          ))}
        </div>
      </section>
    </>
  );
};

export default CmsPage;
